// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_wrapper__hTwrt {
  position: relative;
  padding-top: 32px;
}
.Profile_wrapper__hTwrt .Profile_container__BVoU6 {
  margin: 0 auto;
}
.Profile_wrapper__hTwrt .Profile_row__9gS0i {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.Profile_wrapper__hTwrt .Profile_links__We7jv {
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-top: 24px;
}

@media (max-width: 1100px) {
  .Profile_wrapper__hTwrt .Profile_row__9gS0i {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .Profile_wrapper__hTwrt .Profile_links__We7jv {
    display: block;
  }
  .Profile_rockets_wrapper_padding__8g9R0 {
    padding-top: 75px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;AADJ;;AAKA;EAGE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EAJF;EAOA;IACE,cAAA;EALF;EASD;IACC,iBAAA;EAPA;AACF","sourcesContent":[".wrapper {\n  position: relative;\n  padding-top: 32px;\n\n  .container {\n    margin: 0 auto;\n  }\n\n  .row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  .links {\n    display: flex;\n    gap: 24px;\n    justify-content: space-between;\n    margin-top: 24px;\n  }\n}\n\n@media (max-width: 1100px) {\n .wrapper {\n\n  .row {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .links {\n    display: block;\n  }\n }\n\n .rockets_wrapper_padding {\n  padding-top: 75px;\n }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Profile_wrapper__hTwrt`,
	"container": `Profile_container__BVoU6`,
	"row": `Profile_row__9gS0i`,
	"links": `Profile_links__We7jv`,
	"rockets_wrapper_padding": `Profile_rockets_wrapper_padding__8g9R0`
};
export default ___CSS_LOADER_EXPORT___;
